import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { RegisterPage } from './register';

@NgModule({
  declarations: [
    RegisterPage,
  ],
  imports: [
    IonicPageModule.forChild(RegisterPage),
  ],
  exports:
  [
    RegisterPage
  ]
})
export class RegisterPageModule {}



// WEBPACK FOOTER //
// ./src/pages/register/register.module.ts